const cityTable = {
  // West Michigan / Battle Creek area cities
  // Keys are Google Ads location IDs where applicable
  1020045: "Battle Creek",
  1020046: "Kalamazoo",
  1020047: "Portage",
  1020048: "Grand Rapids",
  1020049: "Wyoming",
  1020050: "Holland",
  1020051: "Muskegon",
  1020052: "Lansing",
  1020053: "East Lansing",
  1020054: "Jackson",
  1020055: "Marshall",
  1020056: "Coldwater",
  1020057: "Hastings",
  1020058: "Allegan",
  1020059: "Plainwell",
  1020060: "Otsego",
  1020061: "Paw Paw",
  1020062: "Three Rivers",
  1020063: "Sturgis",
  1020064: "Albion",
  1020065: "Charlotte",
  1020066: "Eaton Rapids",
  1020067: "Springfield",
  1020068: "Galesburg",
  1020069: "Augusta",
  1020070: "Richland",
  1020071: "Comstock",
  1020072: "Mattawan",
};

export const cityName = (city, def = "West Michigan") => {
  return def;
};

export const textReplacement = (personalizedTextRef, replacementContainerClassName, textToReplaceWith) => {
  let personalizedElments;
  if (personalizedTextRef.current) {
    personalizedElments = personalizedTextRef.current.getElementsByClassName(replacementContainerClassName);
    for (const personalizedElement of personalizedElments) {
      personalizedElement.innerText = textToReplaceWith;
    }
  }
};

export const getCity = () => {
  try {
    const { city } = JSON.parse(window.sessionStorage.getItem("rFprAn"));
    return city;
  } catch (e) {
    return null;
  }
};

export const getLocPhysicalAndCity = () => {
  try {
    const { city, locphysical, campaigns } = JSON.parse(window.sessionStorage.getItem("rFprAn"));
    return { city, locphysical, campaigns };
  } catch (e) {
    return {};
  }
};

// returns a string with value tracked city name for the header
export const adRefCity = (def) => {
  try {
    const { locphysical, city } = JSON.parse(window.sessionStorage.getItem("rFprAn"));
    if (!(locphysical || city)) {
      return def;
    }
    const cityNameFromTable = cityTable[locphysical];
    if (!!city && cityNameFromTable === undefined) {
      return `Serving ${cityName(city)} & Surrounding Areas`;
    }
    if (!cityNameFromTable) {
      return def;
    }
    return `Serving ${cityNameFromTable}, MI and surrounding areas`;
  } catch (e) {
    return def;
  }
};

// returns a string with value tracked city name for text replacement
export const adRefCityText = (def, { city, locphysical }) => {
  try {
    if (!(locphysical || city)) {
      return def;
    }
    const cityNameFromTable = cityTable[locphysical];
    if (!!city && cityNameFromTable === undefined) {
      return cityName(city);
    }
    if (!cityNameFromTable) {
      return def;
    }
    return cityNameFromTable;
  } catch (e) {
    return def;
  }
};
